module.exports = __webpack_public_path__ + "img/logoBj.60ae431f.png";